// Generator registration. main.ts calls this once on startup.
import { registerLayer, getLayerSpec } from '@/core/pipeline';
import type { LayerKind } from '@/core/types';
import { solidSpec } from './solid';
import { gradientSpec } from './gradient';
import { dotgradSpec } from './dotgrad';
import { latticeSpec } from './lattice';
import { perlinSpec } from './perlin';
import { worleySpec } from './worley';
import { voronoiSpec } from './voronoi';
import { cellularSpec } from './cellular';
import { imageSpec } from './image';

const ALL = [
  solidSpec,
  gradientSpec,
  dotgradSpec,
  perlinSpec,
  worleySpec,
  voronoiSpec,
  latticeSpec,
  cellularSpec,
  imageSpec,
];

export function registerAllGenerators(): void {
  for (const spec of ALL) {
    if (!getLayerSpec(spec.kind)) registerLayer(spec);
  }
}

export const GENERATOR_KINDS: LayerKind[] = ALL.map((s) => s.kind);
